
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import RoutesContent from "./components/RoutesContent.vue";

export default defineComponent({
  name: "RoutessPage",
  components: {
    BreadCrumb,
    RoutesContent,
  },
});
